import React, { useEffect, useState } from "react";
import "./dashboard.css";
import { Col, message, Row } from "antd";
import { appName } from "../../../config/url-config";
import PaymentHistory from "./components/client/payment_history";
import StockRealTime from "./components/client/stock_real_time";
import StorageCost from "./components/client/storage_cost";
import SummaryClientDashboard from "./components/client/summary_client";
import FishStockUpdate from "./components/client/fish_stock_update";
import API from "../../../services/api-request";
import { useSearchParams } from "react-router-dom";
import { getDataLogin } from "../../../utils/getDataLogin";

const DashboardClient = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [loading, setLoading] = useState(false);
  const [dataTop5, setDataTop5] = useState(null);

  const data = getDataLogin();

  console.log(data.id);

  const getTop5 = () => {
    let url = `dashboard/summary-customer?stock=available`;

    if (searchParams.get("stock")) {
      url += `?stock=${searchParams.get("stock")}`;
    }

    setLoading(true);
    API.Post(url)
      .then((result) => {
        setLoading(false);

        setDataTop5(result?.data);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
        message.info("Failed Fetch Top 5");
      });
  };

  useEffect(() => {
    document.title = `Dashboard | ${appName}`;
    getTop5();
  }, []);

  useEffect(() => {
    getTop5();
  }, [searchParams]);

  return (
    <>
      <SummaryClientDashboard />
      <br />

      <Row gutter={[16, 16]}>
        <Col lg={12} md={12} sm={12} xs={24}>
          <StockRealTime idClient={data?.id} />
        </Col>
        <Col lg={12} md={12} sm={12} xs={24}>
          <StorageCost idClient={data?.id} />
        </Col>
      </Row>
      <br />
      <Row gutter={[16, 16]}>
        <Col lg={8} md={8} sm={8} xs={24}>
          <FishStockUpdate data={dataTop5?.data?.product} loading={loading} />
        </Col>
        <Col lg={16} md={16} sm={16} xs={24}>
          <PaymentHistory />
        </Col>
      </Row>
    </>
  );
};

export default DashboardClient;
